import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { ProvinceService } from '../../../../services/province/province.service';
import { CountryService } from '../../../../services/country/country.service';
import { CustomersService } from '../../../../services/customer/customers.service';
import { CustomerInfoService } from '../../../../services/customer/customerinfo.service';
import { CustomerBasicInfo, CustomerCompanyData } from '../../../../models/customer.model';
import { ClassificationService } from '../../../../services/classification/classification.service';
import { Classification } from '../../../../models/classification.model';
import { EmploymentService } from '../../../../services/employment/employment.service';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { LoyaltyParamsService } from '../../../../services/loyalty/params.service';
import { SourceSystemService } from '../../../../services/source-system/source-system.service';


@Component({
  selector: 'app-customer-company-basic',
  templateUrl: './customer-company-basic.component.html',
  styleUrls: ['./customer-company-basic.component.css'],
  providers: [CustomersService]
})
export class CustomerCompanyBasicComponent implements OnInit {

  @Input() customerId: string;
  @Input() editMode: boolean;
  @Input() validationForm: boolean;

  @Output() basicInfoLoaded = new EventEmitter();
  @Output() myCustomerCodeLoaded = new EventEmitter();
  @Output() dirtyFormData = new EventEmitter();

  isNewCustomerData: boolean;
  canEditCustomerCode: boolean;
  defaultSourceSystem = null;
  form: FormGroup;
  //countries: SelectItem[];
  countries: Array<any>
  provinces: SelectItem[];
  source_systems: SelectItem[];
  profCategoryValues: SelectItem[];
  profSubcategoryValues: SelectItem[];
  employments: SelectItem[];
  classifications: any[];
  invalidSubmit = false;

  model = {
    country: null
  }

  private myCustomerData;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private countryService: CountryService,
    private provinceService: ProvinceService,
    private companyService: CustomersService,
    private customerService: CustomerInfoService,
    private classificationService: ClassificationService,
    private employmentService: EmploymentService,
    private sourceSystemService: SourceSystemService,
    private srvParam: LoyaltyParamsService
  ) { }

  ngOnInit() {
    this.loadClassificationValues();
    //this.loadCountries();
    this.loadProvinces();
    this.loadSourceSystems();
    this.loadEmployments();

    let customer: Observable<{
      customerData: CustomerBasicInfo,
      companyData: CustomerCompanyData[],
      classificationData: any[],
      defSourceSystem: any;
    }>;

    const searchParamSource = [
      { key: 'param_group', value: 'CustomerDB' },
      { key: 'description', value: 'DefaultSourceSystem' }
    ];

    this.srvParam.list(null, null, searchParamSource).subscribe(paramSource => {
      if (this.customerId === undefined) {
        customer = Observable.of({
          customerData: new CustomerBasicInfo(),
          companyData: [ new CustomerCompanyData() ],
          classificationData: null,
          defSourceSystem: paramSource
        });
      } else {
        customer = Observable.zip(
          this.customerService.getBasicInfo(this.customerId),
          this.companyService.getCompanyData(this.customerId),
          this.customerService.getClassification(this.customerId),
        ).switchMap(([customerData, companyData, classificationData]) => {

          this.basicInfoLoaded.emit(customerData);
          this.myCustomerData = customerData;
          this.myCustomerCodeLoaded.emit(this.myCustomerData.customerCode);

          if (classificationData.length === 0) {
            return Observable.of({
              customerData: customerData,
              companyData: companyData,
              classificationData: [],
              defSourceSystem: paramSource
            });
          }

          const classifications: Array<Observable<Classification>> = [];
          for (const classification of classificationData) {
            classifications.push(this.classificationService.getDetail(classification.classification_detail_id));
          }

          return Observable.zip(...classifications).map((res: any[]) => {
            const classificationDetails = [];

            for (const classificationDetail of res) {
              const customerClassification = classificationData.find(c => classificationDetail.id === c.classification_detail_id);
              classificationDetails.push({
                id: customerClassification.id,
                classification_id: classificationDetail.certification_id,
                classification_detail_id: customerClassification.classification_detail_id,
                code: classificationDetail.code,
                description: classificationDetail.description,
              });
            }

            return {
              customerData: customerData,
              companyData: companyData,
              classificationData: classificationDetails,
              defSourceSystem: paramSource
            };
          });
        });
      }

      customer.subscribe(({ customerData, companyData, classificationData, defSourceSystem }) => {
        const address = companyData.shift();
        this.basicInfoLoaded.emit(address);

        if (defSourceSystem.data.length > 0) {
          this.defaultSourceSystem = defSourceSystem.data[0].param_code
        }

        this.isNewCustomerData = customerData.id == null || customerData.id === undefined;

        if (classificationData) {
          classificationData.sort((a, b) => a.certification_id - b.certification_id);
        }
        this.classifications = classificationData;

        if(address && address.country_id && address.country_id>0){
          let searchCountries = [
            {key: 'id',value: address.country_id.toString()},
            {key: 'flg_state',value: "0"}
          ];
          this.countryService.list(null,null,searchCountries).subscribe(res=>{
            this.countries = [];
            if(res && res.data){
              this.countries = res.data;
              this.model.country = this.countries[0];
            }
          });
        }


        this.form = this.fb.group({
          company_name: [ address.company_name || '', Validators.required ],
          company_vat_code: [ address.vat_code || '', Validators.required ],

          company_address_id: address.id || '',
          company_address: [ address.address || '', Validators.required ],
          company_address_number: [ address.address_number || '', Validators.required ],
          company_zip_code: [ address.zip_code || '', Validators.required ],
          company_country_id: [ address.country_id || '', Validators.required ],
          company_province_id: [ address.province_id || '', Validators.required ],
          company_city: [ address.city || '', Validators.required ],
          company_phone_primary: [ address.phone_primary || '', KoncentroValidators.phoneRequired ],
          company_phone_mobile: [address.phone_mobile || '', KoncentroValidators.phone ],
          company_email_primary: [ address.email_primary || '', Validators.email ],
          company_email_secondary: [ address.email_secondary || '', KoncentroValidators.emailOrEmpty ],
          company_other_telephone: [ address.other_telephone || '', KoncentroValidators.phone ],

          prof_category_id: (this.classifications && this.classifications[0]) ? this.classifications[0].classification_detail_id : '',
          prof_subcategory_id: (this.classifications && this.classifications[1]) ? this.classifications[1].classification_detail_id : '',

          customer_id: customerData.id,
          source_system: [ this.isNewCustomerData ? this.defaultSourceSystem : customerData.source_system, Validators.required ],
          customer_code: this.isNewCustomerData ? '' : customerData.customerCode,
          group_number: customerData.group_number || '',
          name: [ customerData.name || '', Validators.required ],
          surname: [ customerData.surname || '', Validators.required ],
          fiscal_code: [ customerData.fiscal_code || '', Validators.required ],
          email: [ customerData.email_primary || '', Validators.email ],
          phone_primary: [ customerData.phone_primary || '', KoncentroValidators.phoneRequired ],
          phone_mobile: [ customerData.phone_mobile || '', KoncentroValidators.phone ],
          employment_id: customerData.employment_id || '',

          flag_register_name: customerData.flag_register_name === '1',
          flag_general_communications: customerData.flag_general_communications === '1',
          flag_market_research: customerData.flag_market_research === '1',
          flag_privacy: [customerData.flag_privacy === '1', Validators.requiredTrue],
          flag_profiling: customerData.flag_profiling === '1',
          flag_marketing_activities: customerData.flag_marketing_activities === '1',
          flag_purchase_communications: customerData.flag_purchase_communications === '1',
          flag_push_notifications: customerData.flag_push_notifications === '1',
        });

        if (!this.isNewCustomerData) {
          this.form.get('source_system').disable({onlySelf: true});
          this.form.get('customer_code').disable({onlySelf: true});
        } else {
          this.sourceSystemChange()
        }

        this.onChanges();

      });
    });
  }

  onChanges(): void {
    this.form.valueChanges.subscribe(() => this.dirtyFormData.emit(this.form.dirty));
  }

  loadClassificationValues() {
    this.classificationService.getTypes('customer').switchMap(classificationTypes => {
      return this.classificationService.getList(classificationTypes[0].id);
    }).subscribe(classifications => {

      this.classificationService.getDetails(classifications[0].id).subscribe(res => {
        this.profCategoryValues = [{ label: '', value: '' }];
        for (const classification of res) {
          this.profCategoryValues.push({ label: classification.description, value: classification.id });
        }
      });

      this.classificationService.getDetails(classifications[1].id).subscribe(res => {
        this.profSubcategoryValues = [{ label: '', value: '' }];
        for (const classification of res) {
          this.profSubcategoryValues.push({ label: classification.description, value: classification.id });
        }
      });
    });
  }
/*
  loadCountries() {
    this.countries = [];
    this.countryService.getAll().subscribe(res => {
      this.countries = [{ label: '', value: '' }];
      for (const country of res) {
        this.countries.push({ label: country.name, value: country.id });
      }
    });
  }
*/
  loadProvinces() {
    this.provinceService.getAll().subscribe(res => {
      this.provinces = [{ label: '', value: '' }];
      for (const province of res) {
        this.provinces.push({ label: province.name, value: province.id });
      }
    });
  }
  loadSourceSystems() {
    this.sourceSystemService.getList().subscribe(resSourceSystems => {
      this.source_systems = [{ label: '', value: '' }];
      for (const soruceSystem of resSourceSystems) {
        this.source_systems.push({
          value: soruceSystem.id,
          label: soruceSystem.name + ' (' + soruceSystem.description + ')'
        });
      }
    });
  }

  loadEmployments() {
    this.employmentService.getAll().subscribe(res => {
      this.employments = [{ label: '', value: '' }];
      for (const employment of res) {
        this.employments.push({ label: employment.name, value: employment.id });
      }
    });
  }

  /*** Gestione autocomplete Countries */
  filterCountrySingle(event){
    if(event){
      let search = [
        {key: 'name',value: event.query},
        {key: 'flg_state',value: "0"}
      ];
      this.countryService.list(null,null,search).subscribe(res=>{
        this.countries = [];
        if(res && res.data){
          this.countries = res.data;
        }
      })
    }
  }
  onSelectCountry(event){
    this.form.get('company_province_id').setValue(null);
    this.provinceService.getAll(event.id).subscribe(res => {
      this.provinces = [{ label: '', value: '' }];
      for (const province of res) {
        this.provinces.push({ label: province.name, value: province.id });
      }
    });

  }
  onClearCountry(){
    this.form.get('company_country_id').setValue(null);
    this.form.get('company_province_id').setValue(null);
    this.model.country = null;
  }
  /*******/

  sourceSystemChange() {
    this.canEditCustomerCode = +this.form.get('source_system').value !== +this.defaultSourceSystem;

    if (this.canEditCustomerCode) {
      this.form.get('customer_code').enable({onlySelf: true});
    } else {
      this.form.get('customer_code').disable({onlySelf: true});
    }
  }

  save() {
    this.invalidSubmit = false;
    const customer = new CustomerBasicInfo();
    customer.customerCode = this.form.get('customer_code').value;
    customer.group_number = +this.form.get('group_number').value;
    customer.name = this.form.get('name').value;
    customer.surname = this.form.get('surname').value;
    customer.fiscal_code = this.form.get('fiscal_code').value;
    customer.email_primary = this.form.get('email').value;
    customer.phone_primary = this.form.get('phone_primary').value;
    customer.phone_mobile = this.form.get('phone_mobile').value;
    customer.flg_company = 'S';
    customer.employment_id = this.form.get('employment_id').value;
    customer.flag_register_name = this.form.get('flag_register_name').value;
    customer.flag_general_communications = this.form.get('flag_general_communications').value;
    customer.flag_market_research = this.form.get('flag_market_research').value;
    customer.flag_privacy = this.form.get('flag_privacy').value;
    customer.flag_profiling = this.form.get('flag_profiling').value;
    customer.flag_marketing_activities = this.form.get('flag_marketing_activities').value;
    customer.flag_purchase_communications = this.form.get('flag_purchase_communications').value;
    customer.flag_push_notifications = this.form.get('flag_push_notifications').value;
    customer.source_system = this.form.get('source_system').value;

    const company = new CustomerCompanyData();
    company.company_name = this.form.get('company_name').value;
    company.flg_type = 'A';
    company.row_num = 1;
    company.vat_code = this.form.get('company_vat_code').value;
    company.address = this.form.get('company_address').value;
    company.address_number = this.form.get('company_address_number').value;
    company.zip_code = this.form.get('company_zip_code').value;
    company.country_id = this.form.get('company_country_id').value.id;
    company.province_id = this.form.get('company_province_id').value;
    company.city = this.form.get('company_city').value;
    company.phone_primary = this.form.get('company_phone_primary').value;
    company.phone_mobile = this.form.get('company_phone_mobile').value;
    company.email_primary = this.form.get('company_email_primary').value;
    company.email_secondary = this.form.get('company_email_secondary').value;
    company.other_telephone = this.form.get('company_other_telephone').value;

    const classifications = [
      this.form.get('prof_category_id').value,
      this.form.get('prof_subcategory_id').value
    ].filter(v => v !== '').map(classificationId => {
      return { classification_detail_id: classificationId }
    });

    if (!customer.employment_id) {
      delete customer.employment_id;
    }

    if (this.editMode) {
      customer.id = this.form.get('customer_id').value;
      company.id = this.form.get('company_address_id').value;

      Observable.zip(
        this.customerService.putBasicInfo(customer.id, customer),
        this.companyService.updateCompanyData(customer.id, company),
      ).flatMap(() => {
        return this.customerService.setClassification(+customer.id, classifications);
      }).subscribe(() => {
        this.router.navigate(['/customers-infosheet-new'], { queryParams: { saved: 1 } });
      });

      return;
    }

    let customerIdRes = 0;

    this.customerService.post(customer).flatMap((customerRes) => {
      customerIdRes = customerRes.id;
      return this.companyService.addCompanyData(customerIdRes, company);
    }).flatMap(() => {
      return this.customerService.setClassification(customerIdRes, classifications);
    }).subscribe(() => {
      this.router.navigate(['/customers-infosheet-new'], { queryParams: { saved: 1 } });
    });
  }

  customerCodeChange(code) {
    if (code.value !== '') {
      this.customerService.getCustomerNotExists(this.form.get('source_system').value, code.value).subscribe(resp => {
        if (resp === 'CustomerExists') {
          this.form.get('customer_code').setErrors({ 'unique': false });
          this.form.get('customer_code').markAsDirty({ onlySelf: true });
        } else {
          this.form.get('customer_code').setErrors(null);
        }
      });
    } else {
      this.form.get('customer_code').reset();
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-company/customer-company-basic/customer-company-basic.component.ts